/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  PlantConfigInput,
  PlantGeoInput,
  PlantPrefInput,
  CertifiedPlantType,
} from '..';
import {
  serializePlantConfigInput,
  serializePlantGeoInput,
  serializePlantPrefInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdatePlantSettingsInCertifiedPlantInput {
  plantId: string;
  config?: PlantConfigInput;
  geo?: PlantGeoInput;
  plantPref?: PlantPrefInput;
}
const build = (_query: DocumentNode, input: UpdatePlantSettingsInCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.config !== undefined ? `$config: PlantConfigInput = ${serializePlantConfigInput(input.config)}, ` : '' ) + ``+
    ( input.geo !== undefined ? `$geo: PlantGeoInput = ${serializePlantGeoInput(input.geo)}, ` : '' ) + ``+
    ( input.plantPref !== undefined ? `$plantPref: PlantPrefInput = ${serializePlantPrefInput(input.plantPref)}` : '' ) + `){
    updatePlantSettingsInCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.config !== undefined ? 'config: $config,' : '' } 
      ${ input.geo !== undefined ? 'geo: $geo,' : '' } 
      ${ input.plantPref !== undefined ? 'plantPref: $plantPref,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdatePlantSettingsInCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: UpdatePlantSettingsInCertifiedPlantInput): Promise<apollo.FetchResult< { updatePlantSettingsInCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updatePlantSettingsInCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
